/* eslint-disable no-restricted-globals */

const worker = () => {
  var interval;
  const LOCK_ACQUISATION_INTERVAL = 5 * 60 * 1000;

  self.addEventListener('message', function(e){
    switch (e.data) {
      case 'start':
        interval = setInterval(function(){
          self.postMessage('checkLock');
        }, LOCK_ACQUISATION_INTERVAL);

        break;
      case 'stop':
        clearInterval(interval);
        break;
      default: 
    };
  }, false);
}


export default class LockWorker {
  constructor() {
      const code = worker.toString();
      const blob = new Blob(['('+code+')()']);
      return new Worker(URL.createObjectURL(blob));
  }
}